import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

export default function Galeri() {
  const images = [
    { small: "assets/images/footer/1.webp", big: "assets/images/20-kg/1.webp" },
    { small: "assets/images/footer/2.webp", big: "assets/images/20-kg/2.webp" },
    { small: "assets/images/footer/3.webp", big: "assets/images/20-kg/3.webp" },
    { small: "assets/images/footer/4.webp", big: "assets/images/20-kg/4.webp" },
    { small: "assets/images/footer/5.webp", big: "assets/images/20-kg/5.webp" },
    { small: "assets/images/footer/6.webp", big: "assets/images/20-kg/6.webp" },
  ];

  return (
    <div className="container my-5">
      <SRLWrapper>
        <div className="footer-widget__gallery d-flex flex-wrap gap-3">
          {images.map((image, index) => (
            <div key={index} className="footer-widget__gallery__item">
              <a href={image.big} data-attribute="SRL">
                <img
                  src={image.small}
                  alt={`Galeri ${index + 1}`}
                  className="rounded-circle border border-light p-2"
                />
                <span className="footer-widget__gallery__icon icon-plus"></span>
              </a>
            </div>
          ))}
        </div>
      </SRLWrapper>
    </div>
  );
}